import { cn } from '@/lib/utils';
import { FC } from 'react';
import { InputProps, withField } from '../withField';

interface CheckboxProps {
  id?: string;
  onChange?: (newValue: boolean) => void;
  className?: string;
}

export const CheckboxInput: FC<InputProps<boolean> & CheckboxProps> = ({ id, value, onChange, className }) => {
  return (
    <div>
      <input
        id={id}
        checked={value}
        type="checkbox"
        className={cn('w-4 h-4 text-primary-700', className)}
        onChange={onChange ? () => onChange(!value) : event => event.preventDefault()}
      />
    </div>
  );
};

export const CheckboxField = withField<boolean, CheckboxProps>(CheckboxInput);
